import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { Panel, PanelTheme, PanelBorderRadius, PanelBorderStyle, Button, ButtonTheme, SignaturePopup } from '@apply/components';
import { Header, MenuItemOption } from '../../common_v2/components/Header';
import './scss/_signUserAgreement.scss';
import { UpdatedAgreementSignField } from './components/UpdatedAgreementSignField';
import parse from 'html-react-parser';
import { Footer } from '../../common_v2/components/Footer';
import { isMobileScreen } from '@apply/ui';
import { useUserAgreementHtmlQuery, useSaveUserAgreementMutation } from '../queries/userAgreementQueries';

export const BrokerSignAgreementV2 = () => {
    const { bfiUser, user } = useSelector((state) => state);
    const [eSignAgreement, set_eSignAgreement] = React.useState(false);
    const [openESignModal, set_openESignModal] = React.useState(false);
    const mobileScreen = isMobileScreen();

    const saveAgreementMutation = useSaveUserAgreementMutation({
        bfiUser,
        user,
    });

    const { data: userAgreementHtml } = useUserAgreementHtmlQuery();

    const onEsignAgreementCheck = () => {
        set_openESignModal(true);
    };

    const _handleESignModalConfirm = () => {
        set_eSignAgreement(true);
        set_openESignModal(false);
    };

    const _handleESignModalCancel = () => {
        set_eSignAgreement(false);
        set_openESignModal(false);
    };

    const onSubmit = async () => {
        await saveAgreementMutation.mutateAsync();
    };

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.SignUserAgreement} />
                <main>
                    <div className='signBrokerAgreementContent'>
                        <div className='signBrokerAgreementContent-info'>
                            <Panel
                                theme={PanelTheme.Gray}
                                borderRadius={PanelBorderRadius.Medium}
                                borderStyle={PanelBorderStyle.Solid}
                            >
                                <h1> User Agreement Update</h1>
                                <div className='signBrokerAgreementContent-info-row'>
                                    In order to continue to use this website you must agree to the new terms.
                                    <br />
                                    <br /> Please click the consent checkbox below and sign the agreement.
                                </div>
                                <div className='signBrokerAgreementContent-choice-row'>
                                    <UpdatedAgreementSignField
                                        onChange={onEsignAgreementCheck}
                                        signedAgreement={eSignAgreement}
                                    />
                                </div>
                                <div className='signBrokerAgreementContent-actions-row'>
                                    <Button
                                        id='signUpdatedUserAgreement'
                                        theme={ButtonTheme.Primary}
                                        width='240px'
                                        disabled={!eSignAgreement}
                                        handleClick={onSubmit}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </Panel>
                        </div>
                    </div>
                </main>
            </div>
            <Footer showAuthenticatedFooter={true} />
            <SignaturePopup
                id='eSignUpdatedAgreementPopup'
                isOpen={openESignModal}
                onSubmitAgreement={_handleESignModalConfirm}
                onDeclineAgreement={_handleESignModalCancel}
                firstName={bfiUser?.firstName}
                lastName={bfiUser?.lastName}
                width={mobileScreen ? '98%' : '800px'}
                maxWidth={mobileScreen ? '98%' : '800px'}
            >
                {parse(userAgreementHtml ?? '')}
            </SignaturePopup>
        </>
    );
};
